import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getUsersScore, getScoredModels } from "../../state/actions";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import axios from "axios";
import config from "../../modules/config";
import { ProfileAvatar } from "../profile/ProfileAvatar";
import { Typography } from "@mui/material";
import { RootState } from "../../state/reducers";
import { ProfileAvatarAnonymous } from "../profile/ProfileAvatarAnonymous";
import { UsersScore } from "../../types/UsersScore";
import "../profile/profile.style.scss";
import "./userProfileContent.style.scss";
import DataLoaderProgressBar from "../data-loader-progress-bar/DataLoaderProgressBar";

interface Props {
  getUsersScore: (num: number) => void;
  usersScore: UsersScore;
}

const UserProfileContent = (props: any & Props) => {
  const [userInfo, setUserInfo] = useState<any>({});
  const [userRank, setUserRank] = useState("");
  const [userScore, setUserScore] = useState("");
  const [loading, setLoading] = useState(true); // Initialize loading state

  useEffect(() => {
    props.getUsersScore(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.getUsersScore]);

  useEffect(() => {
    setLoading(true); // Start loading
    let athorizedHeader = config.AuthorizationHeader();
    axios
      .get(
        `${process.env.REACT_APP_CROQEE_SERVER_URL}/api/user/` + props.userId,
        athorizedHeader
      )
      .then((res) => {
        setUserInfo(res.data);
        setLoading(false); // Stop loading after data is fetched
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // Stop loading on error
      });
  }, [props.userId]);

  useEffect(() => {
    if (props.usersScore.data) {
      const user = props.usersScore.data.find(
        (user) => user._id === props.userId
      );
      if (user) {
        setUserRank(user.rank);
        setUserScore(user.total);
        setLoading(false); // Stop loading once userScore is set
      }
    }
  }, [props.userId, props.usersScore]);

  if (loading) {
    return <DataLoaderProgressBar />;
  }

  return (
    <>
      {userInfo && (
        <div className="userProfile">
          <div className="profile__img-name-wrapper">
            <div className="profile__img-name-wrapper__img">
              {userInfo.img?.image_data ? (
                <ProfileAvatar
                  imageSrc={`${process.env.REACT_APP_CROQEE_SERVER_URL}/user-image/${userInfo?.img?.image_data}`}
                />
              ) : (
                <ProfileAvatarAnonymous />
              )}
            </div>
            <div className="profile__img-name-wrapper__name">
              <span>Name</span>
              <h1>{userInfo.name}</h1>
            </div>
          </div>
          <div className="profile__ranking">
            <h2>
              Rank #
              <span className="profile__ranking__highlight">{userRank}</span>
            </h2>
            <h2>
              Score{" "}
              <span className="profile__ranking__highlight">{userScore}</span>
            </h2>
          </div>
          {/* <div className="profile__userInfo">
            <span>Email</span>
            <div className="profile__userInfo__container">
              <Typography variant="body2" style={{ fontSize: "1rem" }}>
                {userInfo.email}
              </Typography>
            </div>
          </div> */}
          {userInfo.city && (
            <div className="profile__userInfo">
              <span>Location</span>
              <div className="profile__userInfo__container">
                <Typography variant="body2" style={{ fontSize: "1rem" }}>
                  {userInfo.city}
                </Typography>
              </div>
            </div>
          )}
          {userInfo.birthDate && (
            <div className="profile__userInfo">
              <span>Birthdate</span>
              <div className="profile__userInfo__container">
                <Typography variant="body2" style={{ fontSize: "1rem" }}>
                  userInfo.birthDate.substring(0, 10)
                </Typography>
              </div>
            </div>
          )}
          {userInfo.behance ||
            userInfo.facebook ||
            userInfo.instagram ||
            (userInfo.website && (
              <div className="profile__links">
                <p>Links</p>
              </div>
            ))}
          {userInfo.behance !== undefined && (
            <a href={userInfo.behance} className="profile__links__icons">
              <i className={"fab fa-2x fa-behance "} />
            </a>
          )}
          {userInfo.facebook !== undefined && (
            <a href={userInfo.facebook} className="profile__links__icons">
              <i
                className={"fab fa-2x fa-facebook"}
                // style={{ color: "#b8b8b8", margin: "1rem" }}
              />
            </a>
          )}
          {userInfo.instagram !== undefined && (
            <a href={userInfo.instagram} className="profile__links__icons">
              <i
                className={"fab fa-2x fa-instagram"}
                //style={{ color: "#b8b8b8", margin: "1rem" }}
              />
            </a>
          )}
          {userInfo.website !== undefined && (
            <a href={userInfo.website} className="profile__links__icons">
              <i
                className={"far fa-2x fa-user-circle"}
                // style={{ color: "#b8b8b8", margin: "1rem" }}
              />
            </a>
          )}{" "}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { usersScore, user } = state;
  return { usersScore, user };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getUsersScore: () => dispatch(getUsersScore()),
    getScoredModels: () => dispatch(getScoredModels()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileContent);
